import React from "react"
import { TouchableOpacity, View } from "react-native"
import { RadioButtonProps } from "./props"
import { style as styles } from "./styles"
import { useColor } from "app/theme/getThemes"

// Simple reusable component, handles simple ui or functions
export const RadioButton = (props: RadioButtonProps) => {
  const { children, checked, ...restProps } = props
  const { companyTheme } = useColor()

  // --------------------RENDER
  return (
    // TODO enhancement to able to set the value of the button
    <View style={styles.container}>
      <TouchableOpacity style={styles.radioButton} {...restProps}>
        <View
          style={[
            styles.radioButtonIcon,
            checked && styles.checkedButton,
            { backgroundColor: checked && companyTheme?.first },
          ]}
        />
      </TouchableOpacity>
      {children}
    </View>
  )
}
